import React from "react";
import MenuItem from './menu-item';
import LanguageSelector from './language-selector';


function MenuList(props) {
  const items = props.menuitems;
  const menuItems = items.map(menuItem =>
    // Key should be specified inside the array.
    <MenuItem
      key={menuItem.name.toString()}
      value={menuItem} 
      closeNav={props.closeNav}
      />
  );
  
  return (
    <ul>
       {menuItems}
    </ul>
  );
}

export default class Menu extends React.Component {
    render() {
        return (
            <div className="flex-menu">
                <MenuList menuitems={this.props.menuitems} closeNav={this.props.closeNav}/>
                <LanguageSelector languages={this.props.langMenu} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/menu/menu.js